import React, { createContext, useState, useCallback } from "react";
import apiService from '../services/api.service';

export const RendererContext = createContext();

export const RendererProvider = ({ children }) => {
  const [rendererList, setRendererList] = useState([]);
  const [rendererLoading, setRendererLoading] = useState(false);
  const [error, setError] = useState(null);
  
  // ✅ Add useCallback to stabilize function reference
const fetchRenderersByOrg = useCallback(async (orgId) => {
  if (!orgId) return [];
  
  setRendererLoading(true);
  try {
    const data = await apiService.getRenderersByOrganization(orgId);
    
    let renderers = [];
    if (data?.data && Array.isArray(data?.data?.renderers)) {
      renderers = data?.data?.renderers;
    } else if (data && Array.isArray(data?.data)) {
      renderers = data?.data;
    } else if (Array.isArray(data?.renderers)) {
      renderers = data?.renderers;
    }
    
    setRendererList(renderers);
    setError(null);
    return { renderers }; // ✅ Return consistent format
  } catch (err) {
    console.error(`Error fetching renderers for organization ${orgId}:`, err);
    setError(err.message);
    return { renderers: [] };
  } finally {
    setRendererLoading(false);
  }
}, []); // ✅ Empty deps - stable reference
  
  const getRendererDetails = (rendererId) => {
    return rendererList.find(renderer => renderer.renderer_id === rendererId) || null;
  };

  return (
    <RendererContext.Provider value={{ 
      rendererList, 
      getRendererDetails,
      fetchRenderersByOrg,
      rendererLoading,
      error
    }}>
      {children}
    </RendererContext.Provider>
  );
};